import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.custom-attributes', {
        url: '/custom-attributes',
        component: 'companyUserDirectoriesManageGroupCustomAttributes',
        resolve: {
            customAttributes,
        },
    });
}

/** @ngInject */
function customAttributes(companyId, group, GroupsResource,) {
    return GroupsResource.getCustomAttributes(companyId, group.id);
}


// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/custom-attributes/group-custom-attributes.state.js